import { useContent } from "@/shared/lib/i18n";

const STEP_IMAGES = [
  "/illustrations/steps/step_1.svg",
  "/illustrations/steps/step_2.svg",
  "/illustrations/steps/step_3.svg",
  "/illustrations/steps/step_4.svg",
];

export function HowItWorks() {
  const { howItWorks } = useContent();
  const titleLines = howItWorks.title.split("\n");

  return (
    <section className="py-16 px-[14px] lg:py-24 lg:px-8" id="how-it-works">
      <div className="mx-auto max-w-[1760px] flex flex-col gap-3">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 items-end">
          <h2 className="font-display text-[32px] lg:text-[52px] leading-tight text-white">
            {titleLines[0]}
            <br />
            {titleLines[1]}
          </h2>
          <p className="text-[15px] leading-relaxed">{howItWorks.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-[30px]">
          {howItWorks.steps.map((step, i) => (
            <div
              key={i}
              className="relative bg-[#8C8C8C]/15 backdrop-blur-[2px] border border-white/6 rounded-2xl pt-10 flex flex-col items-center w-full lg:p-6 lg:pt-10 lg:h-[480px] lg:max-w-[420px]"
            >
              <div
                className="absolute -top-[30px] left-1/2 -translate-x-1/2 w-[60px] h-[60px] rounded-full flex items-center justify-center text-[32px] font-bold shrink-0"
                style={{ background: "linear-gradient(135deg, #f89a09, #fec201)", color: "#070707" }}
              >
                {i + 1}
              </div>

              <div className="text-center">
                <h2 className="text-[24px] lg:text-[31px] font-semibold text-white mb-2">{step.title}</h2>
                <p className="text-sm text-muted-fg leading-relaxed">{step.description}</p>
              </div>

              <div className="w-full mt-auto lg:flex-1 lg:flex lg:items-end lg:justify-center lg:pb-2">
                <img
                  src={STEP_IMAGES[i]}
                  alt={step.title}
                  className="w-full aspect-square lg:aspect-auto lg:h-full object-contain object-bottom"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
